"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _style = require("../utils/style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  left: 0;\n  top: 30px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  top: 60px;\n  left: 30px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  left: 60px;\n  top: 30px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  left: 30px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  animation: ", " ", "s ease alternate infinite;\n  transform: scale(0.2);\n  &::before {\n    position: absolute;\n    content: '';\n    left: 50px;\n    top: 0;\n    width: 50px;\n    height: 80px;\n    background: ", " ;\n    border-radius: 50px 50px 0 0;\n    transform: rotate(-45deg);\n    transform-origin: 0 100%;\n  }\n  &::after {\n    position: absolute;\n    content: '';\n    left: 50px;\n    top: 0;\n    width: 50px;\n    height: 80px;\n    background:", " ;\n    border-radius: 50px 50px 0 0;\n    left: 0;\n    transform: rotate(45deg);\n    transform-origin: 100% 100%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  margin: 75px;\n  display: inline-block;\n  vertical-align: middle;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n 0% {\n top: 19px;\n left: 19px;\n}\n 100% {\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var load = (0, _styledComponents.keyframes)(_templateObject());

var Container = _styledComponents.default.div(_templateObject2());

var ItemDiv = _styledComponents.default.div(_templateObject3(), load, function (props) {
  return props.speed || 1;
}, function (props) {
  return props.color || '#00adb5';
}, function (props) {
  return props.color || '#00adb5';
});

var ItemFirst = (0, _styledComponents.default)(ItemDiv)(_templateObject4());
var ItemTwo = (0, _styledComponents.default)(ItemDiv)(_templateObject5());
var ItemThree = (0, _styledComponents.default)(ItemDiv)(_templateObject6());
var ItemFour = (0, _styledComponents.default)(ItemDiv)(_templateObject7());

var DiamonLoading = function DiamonLoading(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? _style.commonStyle : _ref$style,
      speed = _ref.speed,
      color = _ref.color;
  return _react.default.createElement(Container, {
    style: style,
    speed: speed,
    color: color
  }, _react.default.createElement(ItemFirst, {
    color: color,
    speed: speed
  }), _react.default.createElement(ItemTwo, {
    color: color,
    speed: speed
  }), _react.default.createElement(ItemThree, {
    color: color,
    speed: speed
  }), _react.default.createElement(ItemFour, {
    color: color,
    speed: speed
  }));
};

var _default = DiamonLoading;
exports.default = _default;